module.exports = __webpack_public_path__ + "57a793d513f030042e725114f5e6aaba.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/page-up.png
// module id = 710
// module chunks = 0